/**
 * @generated SignedSource<<d71b7dbfdba6f346ab607b7f0f50b6cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedRecommendedItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RecommendedItemsCarousel_viewer">;
  readonly " $fragmentType": "HpSharedRecommendedItems_viewer";
};
export type HpSharedRecommendedItems_viewer$key = {
  readonly " $data"?: HpSharedRecommendedItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedRecommendedItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedRecommendedItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendedItemsCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5de829eff07dc887c0163308ce19129f";

export default node;
